import { render, staticRenderFns } from "./orderListPage.vue?vue&type=template&id=f65c74e0&"
import script from "./orderListPage.vue?vue&type=script&lang=js&"
export * from "./orderListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f65c74e0')) {
      api.createRecord('f65c74e0', component.options)
    } else {
      api.reload('f65c74e0', component.options)
    }
    module.hot.accept("./orderListPage.vue?vue&type=template&id=f65c74e0&", function () {
      api.rerender('f65c74e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderListPage.vue"
export default component.exports